define('AwaLabs.Google.SiteReviews', [
    'Profile.Model',
    'Google.SiteReviews.View',
    'Google.SiteReviews.Model'
], function AwaLabsGoogleSiteReviews(
    ProfileModel,
    SiteReviewsView,
    SiteReviewsModel
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var layout = application.getComponent('Layout');
            layout.addChildViews('Home.View', {
                'Google.SiteReviews': {
                    'Google.SiteReviews': {
                        childViewIndex: 1,
                        childViewConstructor: function childViewConstructor() {
                            var profilePromise = application.getComponent('UserProfile').getUserProfile();
                            var model = new SiteReviewsModel();
                            var view = new SiteReviewsView({
                                model: model
                            });

                            profilePromise.done(function onResolveProfile() {
                                var realProfile = ProfileModel.getInstance();
                                model.set('store', realProfile.get('store'));
                                model.fetch({
                                    data: {
                                        storeId: realProfile.get('store').get('internalid')
                                    }
                                });
                            });

                            return view;
                        }
                    }
                }
            });
        }
    };
});
